import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Autoplay, EffectCoverflow, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import MatrixHeading from "./MatrixHeading";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./NewBlog.css";

const blogPosts = [
  {
    src: "/Blogposts/blog1.png",
    url: "https://ieee-tems-blogs.medium.com/mastering-css-media-queries-the-ultimate-guide-to-responsive-design-da5bbd414766",
  },
  {
    src: "/Blogposts/blog2.png",
    url: "https://ieee-tems-blogs.medium.com/mastering-flexbox-a-fun-yet-powerful-css-journey-a7e045d399b8",
  },
  {
    src: "/Blogposts/blog3.png",
    url: "https://ieee-tems-blogs.medium.com/navigating-the-frontend-landscape-lessons-learned-and-resources-that-work-8e835c61f51a",
  },
  {
    src: "/Blogposts/blog4.png",
    url: "https://ieee-tems-blogs.medium.com/git-101-8193542d7f2c",
  },
  {
    src: "/Blogposts/blog5.png",
    url: "https://ieee-tems-blogs.medium.com/mastering-flexbox-a-fun-yet-powerful-css-journey-a7e045d399b8",
  },
  {
    src: "/Blogposts/blog6.png",
    url: "https://ieee-tems-blogs.medium.com/from-code-to-cloud-deploying-maven-projects-on-aws-3733e60a52ef",
  },
  {
    src: "/Blogposts/blog7.png",
    url: "https://ieee-tems-blogs.medium.com/the-linux-weatherman-crafting-accurate-reports-from-scratch-8887a0b32a77",
  },
];

/* ── Coverflow carousel (converted from Skiper47 Carousel_001) ── */
const BlogCarousel = ({ images, loop = true, autoplay = true, spaceBetween = 40 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: 20 }}
      whileInView={{ opacity: 1, translateY: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      className="blg-carousel"
    >
      <Swiper
        spaceBetween={spaceBetween}
        autoplay={
          autoplay
            ? { delay: 2200, disableOnInteraction: false }
            : false
        }
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        loop={loop}
        slidesPerView={2.2}
        breakpoints={{
          0: { slidesPerView: 1.3 },
          700: { slidesPerView: 1.8 },
          1100: { slidesPerView: 2.2 },
        }}
        coverflowEffect={{
          rotate: 0,
          slideShadows: false,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        pagination={{ clickable: true }}
        className="blg-swiper"
        modules={[EffectCoverflow, Autoplay, Pagination]}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index} className="blg-slide">
            <a
              href={image.url}
              target="_blank"
              rel="noopener noreferrer"
              className="blg-slide-link"
            >
              <img className="blg-slide-img" src={image.src} alt="IEEE TEMS Blog" />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.div>
  );
};

const Blog = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.25 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="Blog" ref={sectionRef}>
      <div className="blg-split">
        {/* LEFT — coverflow carousel */}
        <div className="blg-left">
          <BlogCarousel images={blogPosts} showPagination loop autoplay />
        </div>

        {/* RIGHT — title block (title on the right, like Domains) */}
        <div className="blg-right">

          <h2 className="blg-main-heading">
            <MatrixHeading text="Blogs" active={isVisible} />
          </h2>

          <p className="blg-tagline">
            <span className="blg-tagline-row">WORDS</span>
            <span className="blg-tagline-row">WORTH READING</span>
          </p>

          <div className="blg-heading-line" />

          <p className="blg-desc">
            Tutorials, deep dives and lessons from the IEEE TEMS VIT community —
            covering web, CSS, Git, cloud and everything in between.
          </p>

          <a
            href="https://ieee-tems-blogs.medium.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="blg-view-more"
          >
            View More
          </a>

          <p className="blg-mission-text">
            Fresh reads, straight from our writers.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Blog;
